import { IAddress } from './address';
import { IStaffType } from './staff';

export interface IJob {
  id?: string;
  name: string;
  start: string;
  end: string;
  hours: number;
  address: IAddress;
  staff: Array<IStaff>;
  comments: string;
  createdBy?: string;
  createdAt?: number;
  modifiedAt?: number;
  status?: number; // 0 = pending, 1 = full, 2 = started, 3 = ended, 4 = cancelled
  paymentStatus?: PaymentStatus; // 0 = unpaid, 1 = paid, 2 = declined
  total?: number;
}

export interface IStaff {
  staffType: IStaffType;
  level: number;
  quantity: number;
  staffRate: number;
  recruiterRate: number;
  total?: number;
}

export interface IJobStaff {
  id?: string;
  jobId: string;
  userId: string;
  applicationType: IStaffType;
  createdAt?: number;
  modifiedAt?: number;
  status?: JobApplicationStatus;
}

export interface IStaffTypeApplications {
  staffType?: IStaffType;
  confirmed?: number;
  pending?: number;
  declined?: number;
  remaining?: number;
}

export interface IJobCalendarEvent {
  productId: string;
  title: string;
  start: [number, number, number, number, number];
  duration: IJobCalendarDuration;
  description: string;
  location: string;
}

export interface IJobCalendarDate {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

export interface IJobCalendarDuration {
  hours: number;
  minutes: number;
}

export enum JobApplicationStatus {
  Pending = 0,
  Accepted = 1,
  Declined = 2,
  ClockedIn = 3,
  ClockInConfirmed = 4,
  ClockedOut = 5,
  Completed = 6,
  Rated = 7
}

export enum PaymentStatus {
  Unpaid = 0,
  Paid = 1,
  Declined = 2
}

export enum JobStatus {
  Pending = 0,
  Full = 1,
  Started = 2,
  Ended = 3,
  Cancelled = 4
}



// WEBPACK FOOTER //
// ./src/interfaces/jobs.ts